(function($) {$(document).ready(function() {

	let prevScrollState = 'top'; // top || scrolled
	const $btns = $('.course-intro__btns');

	if ($btns.length > 0 && window.innerWidth < 1200) {
		$(window).on('scroll', checkMobileScrollPosition);
		checkMobileScrollPosition();
	}

	function checkMobileScrollPosition(event) {
		if (window.scrollY > $btns.offset().top && prevScrollState !== 'scrolled') {
			$('.course-intro').addClass('scrolled');
			prevScrollState = 'scrolled';
		} else if (window.scrollY <=$btns.offset().top && prevScrollState !== 'top') {
			$('.course-intro').removeClass('scrolled');
			prevScrollState = 'top';
		}
	}

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);